import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../../components/pdf/Table'
import { TableHeadText, TableColText } from '../../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../../components/pdf/Separator'
import View from '../../../../../../components/pdf/View'
import Grid, { Col } from '../../../../../../components/pdf/Grid'
import Text from '../../../../../../components/pdf/Text'

import { useServiceOrder } from '../../../_load/ServiceOrderLoader'

import { calcPercent, filterRepliesByParentReference } from '../../../_helpers/pdfHelpers'

import { YES_AND_NO_TYPES } from '@btime/constants'
import Bar from './Bar'

export default function ComplianteTable({ counters }) {
  const serviceOrder = useServiceOrder()

  const replies = useMemo(() => {
    const respostas = []

    const complianceReplies = serviceOrder.replies.filter(reply => {
      const { value, question } = reply
      const type = question?.type?.name

      return YES_AND_NO_TYPES.includes(type) && value === true
    })

    complianceReplies.forEach(reply => {
      respostas.push({
        comment: reply.notes,
        question: reply.question.name
      })
    })

    return respostas
  }, [serviceOrder.replies])

  const total = counters.affirmativeCount + counters.negativeCount

  const percent = calcPercent(total - counters.nonCompliancesCount, total)

  return (
    <View>
      <Bar backgroundColor={'#d9ead3'}>
        <Grid justify="space-between" gutter={3}>
          <Col gutter={3}>
            <Text bold noWrap>
              Pontos em Conformidade:
            </Text>
          </Col>
          <Col gutter={3}>
            <Text bold noWrap>
              {`${counters.affirmativeCount} de ${total} (${percent}%)`}
            </Text>
          </Col>
        </Grid>
      </Bar>
      {!!counters.affirmativeCount && (
        <>
          <Separator weight={4} />

          <Table justify="space-between" width={'100%'} style={{ pageBreakInside: 'auto' }}>
            <TableRow>
              <TableHeadText align="left">Item em Conformidade</TableHeadText>
              <TableHeadText align="left">Observações</TableHeadText>
            </TableRow>
            {replies?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableColText preLine align="left">
                  {row.question}
                </TableColText>
                <TableColText align="left">{row.comment}</TableColText>
              </TableRow>
            ))}
          </Table>
        </>
      )}
    </View>
  )
}
